// Usar variable de entorno o fallback a versión por defecto
const version = process.env.REACT_APP_SHAKKII_VERSION || '1.24.4';
export default version;
